<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()" >
      Close</ion-button>
    </ion-buttons>
    <ion-title>Plaato Keg</ion-title>
  </ion-toolbar>
</ion-header>
@if (items$ | async; as items) {
  <ion-content>
    <ion-list>
      @for (item of items; track item; let i = $index) {
        <ion-item
          (click)="selectItem(item)" button
          routerLinkActive="router-link-active">
          <ion-label>
            {{item.name}}
          </ion-label>
          @if (item.tap?.name) {
            <ion-label slot="end">
              <ion-icon src="/assets/icons/flat/beer/tap.svg" >
              </ion-icon>
              {{item.tap?.name}}
            </ion-label>
          }
        </ion-item>
      }
    </ion-list>
  </ion-content>
}
